import { lazy } from 'react';
import { TabListEntityTouchpoints } from 'src/compass/pages/riskManagement/EntityTouchpointsPage';
import { TabListToRouteList } from '../../util/TabListToRouteList';
import { ICONS } from '../navigationIcons';

const NavigatorPage = lazy(() => import('src/compass/pages/riskManagement/NavigatorPage'));
const InventoryPage = lazy(() => import('src/compass/pages/riskManagement/InventoryPage'));
const FeederIndexPage = lazy(() => import('src/compass/pages/riskManagement/FeederIndexPage'));

const SceReportsPage = lazy(() => import('src/compass/pages/riskManagement/SceReportsPage'));
const CommunicationsPage = lazy(
  () => import('src/compass/pages/riskManagement/CommunicationsPage')
);
const EntityTouchpointsPage = lazy(() => import('src/compass/pages/riskManagement/EntityTouchpointsPage'));
const SalesDashboardPage = lazy(() => import('src/compass/pages/riskManagement/SalesDashboardPage'));

export const RiskManagementMenu = [
  {
    menuTitle: 'Risk Management',
    path: 'riskmanagement',
    icon: ICONS.user,
    subMenus: [
      {
        title: 'Communications',
        path: 'communications',
        element: <CommunicationsPage />,
        permission: 'COMMUNICATIONS',
      },
      {
        title: 'Entity Touchpoints',
        path: 'entitytouchpoints',
        element: <EntityTouchpointsPage />,
        permission: 'ENTITY_TOUCHPOINTS',
        children: TabListToRouteList(TabListEntityTouchpoints),
      },
      {
        title: 'Feeder Index',
        path: 'feederindex',
        element: <FeederIndexPage />,
        permission: 'FEEDER_INDEX',
      },
      {
        title: 'Inventory',
        path: 'inventory',
        element: <InventoryPage />,
        permission: 'INVENTORY',
      },
      {
        title: 'Navigator',
        path: 'navigator',
        element: <NavigatorPage />,
        permission: 'NAVIGATOR',
      },
      {
        title: 'Sales Dashboard',
        path: 'salesdashboard',
        element: <SalesDashboardPage />,
        permission: 'SALES_DASHBOARD',
      },
      {
        title: 'SCE Reports',
        path: 'scereports',
        element: <SceReportsPage />,
        permission: 'SCE_REPORTS',
      },
    ],
  },
];
